import type { ReactNode } from 'react';
import type { FormField } from '../schema/types';
import { getFieldRenderer, type FieldRenderContext } from './fieldRegistry';

export type { FieldRenderContext };

export function renderField(
  field: FormField,
  context: FieldRenderContext,
): ReactNode {
  try {
    return getFieldRenderer(field.type)(field, context);
  } catch (error) {
    console.error('[renderField]', error);
    return (
      <div key={field.name} style={{ color: 'red', padding: 8 }}>
        Unknown field type: <strong>{field.type}</strong> ({field.name})
      </div>
    );
  }
}

export function renderFields(
  fields: FormField[],
  context: FieldRenderContext,
): ReactNode[] {
  return fields.map((field) => renderField(field, context));
}
